import "../images/qr/narrative-qr-colour.svg";
import "../images/qr/narrative-qr-mono.svg";

const QRCodeStyling = require('./qrcodestyling.js');

function append_qr_code_canvas(container_element, data, qr_icon, qr_colour) {
    if (!container_element) return;

    var qrCode = new QRCodeStyling({
        width: 196,
        height: 196,
        data: data,
        image: qr_icon,
        dotsOptions: {color: qr_colour}
    });

    container_element.innerHTML = "";
    qrCode.append(container_element);
}

function download_qr_code(data, export_options) {
    var qrCode = new QRCodeStyling({
        width: export_options.width,
        height: export_options.height,
        data: data,
        image: export_options.image,
        dotsOptions: {color: export_options.colour}
    });

    qrCode.download({ name: "jellybooks_qr_code", extension: export_options.format });
}

function extract_qr_options() {
    const width_element = document.getElementById("qr_export_width");
    const height_element = document.getElementById("qr_export_height");
    const colour_element = document.getElementById("qr_export_colour");
    const format_element = document.getElementById("qr_export_format");

    const export_options = {
        "width": parseInt(width_element.value),
        "height": parseInt(height_element.value),
        "format": format_element.value
    }
    if (colour_element.value === "mono") {
        export_options['colour'] = '#000000';
    }

    return export_options;
}

export function handleQrCodes() {
    const qr_element = document.getElementById("excerpt-qr-container");

    const exportClickListener = function(event) {
        // Extract the form options
        const export_options = extract_qr_options();

        if (!export_options.hasOwnProperty("colour")) {
            export_options['colour'] = qr_element.dataset.qrColour;
            export_options['image'] = qr_element.dataset.qrIcon;
        } else {
            export_options['image'] = qr_element.dataset.qrIconMono;
        }

        // call download_qr_code()
        download_qr_code(qr_element.dataset.qrCodeContent, export_options);

        event.preventDefault();
    };


    if (qr_element) {
        append_qr_code_canvas(qr_element,
            qr_element.dataset.qrCodeContent,
            qr_element.dataset.qrIcon,
            qr_element.dataset.qrColour
        );

        const qr_export_button = document.getElementById("qr-export-button");
        if (qr_export_button) {
            qr_export_button.addEventListener("click", exportClickListener);
        }
    }
}

export function copyTextToClipboard(text) {
    return navigator.clipboard.writeText(text);
}
